import { useTheme } from '../../../contexts/ThemeContext';

export default function Services() {
  const { isDark } = useTheme();

  const services = [
    {
      icon: 'ri-loop-right-line',
      title: 'AI Workflow Automation',
      description:
        'We design intelligent automation systems that eliminate repetitive manual tasks and streamline internal operations — freeing your team to focus on high-value work.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'AI Customer Engagement',
      description:
        'Deploy AI assistants that capture leads, answer inquiries, schedule appointments, and improve response time around the clock.',
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'AI Data & Insights',
      description:
        'Turn operational data into dashboards and predictive insights that help businesses make smarter, faster decisions.',
    },
    {
      icon: 'ri-links-line',
      title: 'AI System Integrations',
      description:
        'Connect your CRM, communication tools, and internal platforms into a unified AI-powered system that works seamlessly.',
    },
  ];

  return (
    <section
      id="services"
      className="py-32 px-8 lg:px-12 transition-colors duration-300"
      style={{ background: isDark ? '#0f1117' : '#ffffff' }}
    >
      <div className="max-w-7xl mx-auto">
        <p
          className="text-xs font-semibold tracking-[0.25em] uppercase text-[#2563EB] mb-5 text-center"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          What We Build
        </p>

        <h2
          className="text-4xl lg:text-5xl font-bold text-center leading-tight tracking-tight mb-6"
          style={{ fontFamily: 'Montserrat, sans-serif', color: isDark ? '#F9FAFB' : '#111827' }}
        >
          AI Systems Designed for
          <br />
          Real Business Operations
        </h2>

        <p
          className="text-lg text-center max-w-2xl mx-auto mb-20 leading-relaxed"
          style={{
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 400,
            color: isDark ? '#9CA3AF' : '#374151',
          }}
        >
          Every system we build is purpose-built for your workflows — not generic software, but intelligent infrastructure tailored to your operations.
        </p>

        <div className="grid md:grid-cols-2 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative rounded-2xl p-10 border transition-all duration-500 cursor-pointer overflow-hidden"
              style={{
                background: isDark ? '#1a1f2e' : '#F3F4F6',
                borderColor: 'transparent',
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLDivElement).style.borderColor = isDark ? 'rgba(37,99,235,0.4)' : '#E5E7EB';
                (e.currentTarget as HTMLDivElement).style.background = isDark ? '#1e2538' : '#ffffff';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLDivElement).style.borderColor = 'transparent';
                (e.currentTarget as HTMLDivElement).style.background = isDark ? '#1a1f2e' : '#F3F4F6';
              }}
            >
              <div className="absolute top-0 left-0 w-0 group-hover:w-full h-0.5 bg-[#2563EB] transition-all duration-500 rounded-t-2xl"></div>

              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl mb-8 group-hover:bg-[#2563EB] transition-colors duration-300"
                style={{ background: isDark ? '#374151' : '#111827' }}
              >
                <i className={`${service.icon} text-xl text-white`}></i>
              </div>

              <h3
                className="text-xl font-bold mb-4 tracking-tight"
                style={{ fontFamily: 'Montserrat, sans-serif', color: isDark ? '#F9FAFB' : '#111827' }}
              >
                {service.title}
              </h3>
              <p
                className="leading-relaxed text-sm"
                style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontWeight: 400,
                  color: isDark ? '#9CA3AF' : '#374151',
                }}
              >
                {service.description}
              </p>

              <div className="mt-8 flex items-center gap-2 text-[#2563EB] text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span style={{ fontFamily: 'Montserrat, sans-serif' }}>Learn more</span>
                <i className="ri-arrow-right-line text-base"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
